import { render, staticRenderFns } from "./ReturnToFactoryManagementList.vue?vue&type=template&id=68ceb52b&scoped=true"
import script from "./ReturnToFactoryManagementList.vue?vue&type=script&lang=js"
export * from "./ReturnToFactoryManagementList.vue?vue&type=script&lang=js"
import style0 from "./ReturnToFactoryManagementList.vue?vue&type=style&index=0&id=68ceb52b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ceb52b",
  null
  
)

export default component.exports